import { gql } from '@apollo/client';

export const listAggregatedWatchData = gql`
  query listAggregatedWatchData($filter: AggregatedWatchDataFilter) {
    listAggregatedWatchData(filter: $filter) {
      count
      date
    }
  }
`;

export const listCourseWatchData = gql`
  query listCourseWatchData($courseId: ID!, $organizationId: ID) {
    listCourseWatchData(courseId: $courseId, organizationId: $organizationId) {
      id
      name
      email
      progress
      firstTimeWatched
      completedTime
      certificationTime
    }
  }
`;

export const listCoursesWatchData = gql`
  query listCoursesWatchData($organizationId: ID) {
    listCoursesWatchData(organizationId: $organizationId) {
      id
      courseId
      name
      viewsCount
      completedCount
      averageCompletion
      certificatesIssued
      catalogs
      status
    }
  }
`;

export const listGroupWatchData = gql`
  query listGroupWatchData($groupId: ID!, $organizationId: ID!) {
    listGroupWatchData(groupId: $groupId, organizationId: $organizationId) {
      id
      userId
      name
      email
      playlistsCompleted
      coursesCompleted
      episodesCompleted
      certificatesEarned
    }
  }
`;

export const listGroupsWatchData = gql`
  query listGroupsWatchData($organizationId: ID!) {
    listGroupsWatchData(organizationId: $organizationId) {
      id
      name
      ownedBy
      ownedByName
      membersCount
      playlistsCompleted
      coursesCompleted
      episodesCompleted
      certificatesEarned
    }
  }
`;

export const listOrganizationWatchData = gql`
  query listOrganizationWatchData($organizationId: ID!) {
    listOrganizationWatchData(organizationId: $organizationId) {
      id
      userId
      name
      email
      playlistsCompleted
      coursesCompleted
      episodesCompleted
      certificatesEarned
    }
  }
`;

export const listOrganizationsWatchData = gql`
  query listOrganizationsWatchData {
    listOrganizationsWatchData {
      id
      name
      registeredMembers
      playlistsCompleted
      coursesCompleted
      episodesCompleted
      certificatesEarned
    }
  }
`;

export const listPlaylistWatchData = gql`
  query listPlaylistWatchData(
    $groupId: ID
    $playlistId: ID!
    $organizationId: ID!
  ) {
    listPlaylistWatchData(
      groupId: $groupId
      playlistId: $playlistId
      organizationId: $organizationId
    ) {
      ... on GroupPlaylistWatchData {
        id
        groupId
        name
        ownedBy
        ownedByName
        sharedAt
        membersCount
      }
      ... on UserPlaylistWatchData {
        id
        userId
        name
        email
        progress
        invitedAt
        lastReminderAt
      }
    }
  }
`;

export const listPlaylistsWatchData = gql`
  query listPlaylistsWatchData($organizationId: ID!) {
    listPlaylistsWatchData(organizationId: $organizationId) {
      id
      name
      ownerId
      ownerName
      coursesCount
      viewsCount
      completedCount
      averageCompletion
      shareType
      lastReminderAt
    }
  }
`;

export const listPlaylistUserWatchData = gql`
  query listPlaylistUserWatchData(
    $organizationId: ID!
    $playlistId: ID!
    $userId: ID!
  ) {
    listPlaylistUserWatchData(
      organizationId: $organizationId
      playlistId: $playlistId
      userId: $userId
    ) {
      id
      courseId
      name
      progress
      firstTimeWatched
      completedTime
      certificationTime
      status
    }
  }
`;

export const listUserWatchData = gql`
  query listUserWatchData($organizationId: ID!, $userId: ID!) {
    listUserWatchData(organizationId: $organizationId, userId: $userId) {
      id
      courseId
      name
      progress
      firstTimeWatched
      completedTime
      certificationTime
      status
    }
  }
`;
